import { Card, Typography } from "@codat/orchard-ui";
import { ConfigResponse } from "api/shared";

import Button from "components/Button";
import CardContainer from "components/CardContainer";
import Logo from "components/Logo";
import { SecuredByCodat } from "components/SecuredByCodat";

import styles from "./Landing.module.css";

interface LandingProps {
  data: ConfigResponse;
  onClickNext: (
    event: React.MouseEvent<HTMLButtonElement & HTMLAnchorElement>
  ) => void;
  isLoading?: boolean;
}

export const Landing = ({ data, onClickNext, isLoading }: LandingProps) => {
  return (
    <CardContainer>
      <Card className={styles.card} data-testid="hosted-link">
        <div data-testid="landing-card" className={styles.content}>
          <header className={styles.header}>
            <Logo logo={data.logo} clientName={data.clientName} />
          </header>
          <div className={styles.body}>
            <Typography data-testid="page-title" variant="h1" as="h1">
              {data.pageConfiguration.landing.title}
            </Typography>
            <Typography data-testid="landing-body" variant="p" as="p">
              {data.pageConfiguration.landing.body}
            </Typography>
          </div>
          <footer className={styles.footer}>
            <Button
              data-testid="primary-next-btn"
              isLoading={isLoading}
              onClick={onClickNext}
              label="Next"
              type="button"
              analyticsName="Next"
            />
          </footer>
        </div>
      </Card>
      <div className={styles.securedByWrapper}>
        <SecuredByCodat />
      </div>
    </CardContainer>
  );
};
